module.exports = __webpack_public_path__ + "img/icon-anagrafica.41dbeca1.svg";